var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"cost_item",on:{"click":_vm.toCostDetail}},[_c('div',{staticClass:"item_main"},[_c('h3',{staticClass:"cost_name",domProps:{"textContent":_vm._s(_vm.name)}}),(!_vm.status)?_c('span',{staticClass:"remain-operate-span"},[_vm._v(_vm._s(_vm.$t('message["144"]')))]):_c('i',{staticClass:"cubeic-arrow"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }